import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCustomFieldsByQuery } from "services/custom-field.service";
import { CustomFieldDefinition } from "types/CustomField";

// Define the types for your initial state
interface customFieldContainerState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: CustomFieldDefinition[];
}

const initialState: customFieldContainerState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
};

const customFieldContainerSlice = createSlice({
  name: "customfield",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(
      state: customFieldContainerState,
      action: PayloadAction<boolean>
    ) {
      state.isLoading = action.payload;
    },
    setError(
      state: customFieldContainerState,
      action: PayloadAction<{ error: string }>
    ) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state: customFieldContainerState, action: PayloadAction<any>) {
      state.collection = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
  },
});

const { actions, reducer } = customFieldContainerSlice;

export const { setDestroy, setLoading, setError, setData } = actions;
export default reducer;

// Only the newest request may change the state: after a company switch or a reload,
// an older answer would show the wrong list or an error that no longer applies.
let latestRequest = 0;

export const fetchCustomField =
  (companyId: string) => async (dispatch: any) => {
    latestRequest += 1;
    const request = latestRequest;
    dispatch(setLoading(true));
    try {
      // Only document fields: the server has no reader for the other kinds.
      const data = await fetchCustomFieldsByQuery(companyId, "file");
      if (request === latestRequest) dispatch(setData(data));
    } catch (e) {
      const error = "not_fetch";
      if (request === latestRequest) dispatch(setError({ error }));
    }
  };
